'use strict';

exports.__esModule = true;
exports['default'] = getDisplayName;
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/ssc-refer/lib/refer/utils/getDisplayName.js
// module id = 317
// module chunks = 0